export default __webpack_public_path__ + "static/client5-bdc34e945aef198cd89ba8455b85fba7.jpg";